import { LOG_OUT } from "../login/action";
import { SET_AMERICAN_STATES, SET_TOKEN } from "./action";

export const defaultState={
   americanStateList:[],
   bearerTokenlist:""
}

function payCitationReducer(state=defaultState,action){
    switch (action.type) {
       case SET_AMERICAN_STATES:
           return{
               ...state,
               americanStateList:action.payload
           }
        case LOG_OUT:
            return defaultState;
        case SET_TOKEN:
            return {
                ...state,
               bearerTokenlist:action.payload
            }
        default:
          return state;
      }
}

export default payCitationReducer;